import { cn } from '@/lib/utils'

import InlineAudioPlayer from '@/components/markdown/inline-audio-player'

interface SectionAudioPlayerProps {
  audioUrl: string
  className?: string
}

export default function SectionAudioPlayer({ audioUrl, className }: SectionAudioPlayerProps) {
  if (!audioUrl) return null

  return (
    <div className={cn('not-prose heading-audio-row inline-flex shrink-0 items-center align-middle', className)}>
      <InlineAudioPlayer audioUrl={audioUrl} variant="inline" />
    </div>
  )
}
